/**
 * 运单地图监控请求
 */
import request from '@/utils/http';
const otpBaseUrl = '/api-antms/query';

// 运单地图监控-分页查询接口
export const queryMapMonitorList = data => {
    return request({
        url: `${otpBaseUrl}/lsp/transport/mapMonitor/page`,
        method: 'post',
        data
    });
};

// 运单地图监控-列表分页统计数量
export const queryCount = data => {
    return request({
        url: `${otpBaseUrl}/lsp/transport/mapMonitor/pageCount`,
        method: 'post',
        data
    });
};

// 运单地图监控-查询事件管理列表
export const queryEventList = data => {
    return request({
        url: `${otpBaseUrl}/transport/mapMonitor/queryEventList`,
        method: 'get',
        params: data
    });
};

// 运单地图监控-定位信息列表
export const queryPositionList = data => {
    return request({
        url: `${otpBaseUrl}/transport/mapMonitor/queryPositionList`,
        method: 'get',
        params: data
    });
};

// 运单地图监控-零担平台运单状态列表
export const queryLdTrackList = data => {
    return request({
        url: `${otpBaseUrl}/transport/mapMonitor/queryLdTrackList`,
        method: 'get',
        params: data
    });
};

// 运单地图监控-查询计划线
export const queryPlanLine = data => {
    return request({
        url: `${otpBaseUrl}/transport/mapMonitor/queryPlanLine`,
        method: 'get',
        params: data
    });
};

// 运单地图监控-查询当前车辆定位
export const getPosition = data => {
    return request({
        url: `${otpBaseUrl}/transport/mapMonitor/getPosition`,
        method: 'get',
        params: data
    });
};

// 运单地图监控-零担运输单获取零担平台节点
export const getLclNodeByTaskNo = data => {
    return request({
        url: `${otpBaseUrl}/transport/mapMonitor/getLclNodeByTaskNo`,
        method: 'get',
        params: data
    });
};
// 运单地图监控-零担运输获取中交兴路轨迹
export const getLclPointByTask = data => {
    return request({
        url: `${otpBaseUrl}/transport/mapMonitor/getLclPointByTask`,
        method: 'get',
        params: data
    });
};

// 运单地图监控-获取打点统计信息
export const getMonitorStatisticsList = data => {
    return request({
        url: `${otpBaseUrl}/transport/mapMonitor/getMonitorStatisticsList`,
        method: 'get',
        params: data
    });
};
